import routeProviderConfig from './configs/routeProvider.config';

import tos from './components/tos/tos.component';

/**
 * @ngdoc overview
 * @name tos
 * @description
 * This module handles everything for the TOS section.
 */
const tosModule = angular.module('tos', [])
.config(routeProviderConfig)
.component('tos', tos);

export default tosModule.name;



// WEBPACK FOOTER //
// ./src/frontend/modules/tos/index.js